// src/components/TopBar.js
import React from 'react';
import './TopBar.css';
import { FaTwitter, FaInstagram, FaFacebookF, FaYoutube, FaEnvelope } from 'react-icons/fa';
import { FiPhone } from 'react-icons/fi';

export default function TopBar() {
  return (
    <div className="topbar">
      <div className="topbar-left">
        <a href="mailto:info@yeldegirmeniegitimkurumlari.com" className="slogan">
          Mutlu Çocuk Öğrenir !
        </a>
      </div>

      <div className="topbar-right">
        <a
          href="https://www.instagram.com/yeldegirmeniegitimkurumlari/"
          aria-label="Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram />
        </a>

        <a
          href="https://www.facebook.com/yeldegirmeniegitim/?locale=tr_TR"
          aria-label="Facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebookF />
        </a>

        {/* ✅ Yeni: YouTube Butonu */}
        <a
          href="https://www.youtube.com/@yeldegirmeniilkokulu6489"
          aria-label="YouTube"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaYoutube />
        </a>

        <a
          href="mailto:info@yeldegirmeniegitimkurumlari.com"
          aria-label="E-posta"
        >
          <FaEnvelope />
        </a>

        <a
          href="tel:05498303731"
          aria-label="Telefon"
        >
          <FiPhone />0(549) 830 37 31
        </a>
      </div>
    </div>
  );
}
